import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "sr/helpers";
import { ModelBottomItem } from "./SidebarItems";
import { ProfileSwitcherOptions } from "app/pages/module/auth/ProfileSwitcher";
import { RefreshCw } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuth } from "app/pages/module/auth";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { useDispatch, useSelector } from "react-redux";
import { fetchIndividual } from "sr/redux/reducers/individual";
import { AppDispatch, RootState } from "sr/redux/store";
import { DaysConverter } from "sr/helpers/functions/DaysConverter";
import {
  fetchIndividualNotification,
  removeNotificationMessage,
  updateNotificationMessage,
} from "sr/redux/reducers/individualNotification";
import { useSocket } from "app/pages/component/SocketContext";
import { CHAT_TYPE } from "sr/i18n/messages/setting";
import { formatISO } from "date-fns";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";
import { ConditionalWrapper } from "app/pages/module/auth/ConditionalWrapper";
import { NotificationLink } from "sr/helpers/functions/NotificationLink";
import { updateMessage } from "sr/utils/api/cleaner/updateMessage";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { deleteMessage } from "sr/utils/api/cleaner/deleteMessage";
import { readMessage } from "sr/utils/api/cleaner/readMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

export const Header = (props) => {
  const intl = useIntl();
  const { logout } = useAuth();
  const [model, setModel] = useState(false);
  const [userId, setUserId] = useState();
  const [showeffect, setShowEffect] = useState(false);
  const [showRightHeader, setShowRightHeader] = useState(false);
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const data = useSelector((state: any) => state.individual.data);
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const appSettingsReloadSetting = useSelector(
    (s: RootState) => s.appSettings.reloadSetting
  );
  const allmessage = useSelector(
    (state: any) => state.individualNotification.data
  );
  const allmessageRef = useRef(allmessage);
  const HandleClick = () => {
    props.HandleOpen();
  };
  const audioFile = toAbsoluteUrl(
    "/media/notification/notification-18-270129.mp3"
  );

  const socket = useSocket();
  const dispatch = useDispatch<AppDispatch>();
  /* Open/End Model Popup With Effects */
  const HandleModel = () => {
    if (!model) {
      setModel(true);
      setTimeout(() => {
        setShowEffect(true);
      }, 200);
    } else {
      setTimeout(() => {
        setShowEffect(false);
      }, 200);
      setTimeout(() => {
        setModel(false);
      }, 500);
    }
  };
  useEffect(() => {
    const getdetails = getUserDetails();
    setUserId(getdetails?.user_id);
  }, []);
  useEffect(() => {
    (async () => {
      const userFullProfileRes = await getUserFullProfile();
      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, [appSettingsReloadSetting]);
  useEffect(() => {
    if (userId) {
      if (!data) {
        dispatch(fetchIndividual({ id: userId }));
      }
      if (!allmessage?.length) {
        dispatch(fetchIndividualNotification({ userId: userId }));
      }
    }
  }, [userId]);
  const handleNotification = () => {
    if (allmessage?.length < 1) return;
    if (model) {
      setModel(false);
    }
    if (!notificationPopup) {
      setNotificationPopup(true);
      setTimeout(() => {
        setShowEffect(true);
      }, 200);
    } else {
      setTimeout(() => {
        setShowEffect(false);
      }, 200);
      setTimeout(() => {
        setNotificationPopup(false);
      }, 500);
    }
  };
  const sortedMessage = [...(allmessage || [])].sort((a, b) => {
    const adate = new Date(a?.createdAt);
    const bdate = new Date(b?.createdAt);
    return bdate.getTime() - adate.getTime();
  });
  useEffect(() => {
    allmessageRef.current = allmessage;
  }, [allmessage]);
  useEffect(() => {
    if (data?.regionId?.id) {
      setRegionIdMe(data?.regionId?.id);
    }
  }, [data]);
  useEffect(() => {
    if (!userId || !socket) return;

    socket.emit("register", userId);
    socket.emit("getonlineusers", userId);

    const handleSendMessage = ({ messagewithFullData: message }) => {
      if (message) {
        const audio = new Audio(audioFile);

        audio
          .play()
          .catch((error) => console.error("Audio playback failed:", error));
        if (message?.sender_id_type === "cleaner")
          if (Object.values(CHAT_TYPE)?.includes(message?.type)) {
            const currentDateTime = formatISO(new Date());
            const newmessage = { createdAt: currentDateTime, ...message };
            dispatch(
              updateNotificationMessage([
                ...(allmessageRef.current || []),
                newmessage,
              ])
            );
          }
      }
    };
    const handleNotificationMessage = (message) => {
      if (message) {
        const audio = new Audio(audioFile);
        audio
          .play()
          .catch((error) => console.error("Audio playback failed:", error));
        const currentDateTime = formatISO(new Date());
        const newmessage = { createdAt: currentDateTime, ...message };
        dispatch(
          updateNotificationMessage([
            ...(allmessageRef.current || []),
            newmessage,
          ])
        );
      }
    };

    socket.on("sendmessage", handleSendMessage);
    socket.on("notification", handleNotificationMessage);

    return () => {
      socket.off("sendmessage", handleSendMessage);
      socket.off("notification", handleNotificationMessage);
    };
  }, [userId, socket]);

  const handleRead = async (id?: string) => {
    try {
      console.log("handleRead:", id);

      if (!userId) {
        console.log("No userId");
        return;
      }

      const payload = {
        recipient_id: userId,
        ...(id && { id }),
      };

      console.log("Sending payload:", payload);

      const res = await readMessage(payload);

      console.log("Read response:", res);

      if (res?.success === true) {
        const updated = allmessage?.map((item: any) =>
          id
            ? item._id === id
              ? { ...item, readed: true }
              : item
            : { ...item, readed: true }
        );

        dispatch(updateNotificationMessage(updated));
      }
    } catch (e) {
      console.error("handleRead error:", e);
    }
  };

  const handleDelete = async (id?: string) => {
    try {
      if (!userId || !id) return;

      const payload = {
        recipient_id: userId,
        id,
      };

      const res = await deleteMessage(payload);

      if (res?.success === true) {
        dispatch(removeNotificationMessage({ id }));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleRemove = async (id?: any) => {
    try {
      const payload = {
        id: id,
        readed: true,
      };
      const updateMessagePayload = allmessage?.systemmessage?.map(
        (item: any) => ({ ...item, readed: true })
      );
      const res = await updateMessage(id ? payload : updateMessagePayload);
      if (res?.success === true) {
        dispatch(removeNotificationMessage({ id: id }));
      }
    } catch (e) {}
  };

  return (
    <div
      className={`${
        props.isOpen ? "lg:pl-48" : "lg:pl-16"
      } duration-300 [border border-b-text-gray-500] relative z-20`}
    >
      <nav className={`border border-b-text-gray-500 relative z-20`}>
        <div className="w-full flex bg-white justify-between items-center pr-5 space-x-5">
          <div className="flex lg:block space-x-2">
            <div
              onClick={HandleClick}
              className="bg-[#2d2d2d] lg:hidden flex justify-center items-center px-3 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
                role="img"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
                className="w-6 h-6 text-white"
              >
                <path d="M3.5 5.25h13a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-.5a.5.5 0 01.5-.5zm13 4h-13a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-.5a.5.5 0 00-.5-.5zm0 4h-13a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-.5a.5.5 0 00-.5-.5z"></path>
              </svg>
            </div>
            <div className="flex-none w-[110px]">
              <img
                className="w-full py-1.5"
                src={toAbsoluteUrl("/media/logos/logo2.png")}
                alt="logo"
              />
            </div>
          </div>
          <div className="flex items-center w-full space-x-2 py-3">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="location-dot"
              className="w-4 h-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                fill="currentColor"
                d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
              ></path>
            </svg>
            <div className="">{data?.regionId?.city}</div>
          </div>
          <div
            onClick={() => setShowRightHeader(!showRightHeader)}
            className={`items-center lg:hidden ${
              showRightHeader ? "hidden" : "flex md:flex"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              focusable="false"
              role="img"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="w-6 h-6"
            >
              <path d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.992-5.996-4.5-9-4.5z"></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </div>
          <a
            href="https://support.janijobs.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 px-5 lg:px-0"
          >
            <FontAwesomeIcon
              icon={faCircleQuestion}
              className="text-lg lg:text-xl"
            />
            <span>
              <FormattedMessage id="COMMON.HELP" defaultMessage="Help" />
            </span>
          </a>
          <div
            className={`${
              showRightHeader ? "translate-x-0 delay-100" : "translate-x-[100%]"
            } lg:flex lg:flex-row flex-col lg:space-x-4 space-y-5 lg:space-y-0 md:fixed fixed lg:static bg-white inset-0 shadow-xl transition duration-300 lg:shadow-none lg:translate-x-0 z-20 lg:z-50 xl:z-50`}
          >
            <div
              onClick={handleNotification}
              className="flex items-center w-full space-x-2 relative cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
                role="img"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
                height="24"
                className="w-5 h-5"
              >
                <path d="M10 2a1.5 1.5 0 00-1.5 1.5v.229A5.002 5.002 0 005 8.5V12l-1.854 1.854a.5.5 0 00-.146.353v.293a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-.293a.5.5 0 00-.146-.353L15 12V8.5a5.002 5.002 0 00-3.5-4.771V3.5A1.5 1.5 0 0010 2zm.002 16a2.5 2.5 0 01-2.45-2h4.9a2.5 2.5 0 01-2.45 2z"></path>
              </svg>
              <span>
                <FormattedMessage
                  id="RECRUITER.TOPBAR.MENU.NOTIFICATION"
                  defaultMessage="Notification"
                />
              </span>
              {allmessage?.filter((m) => !m.readed).length > 0 && (
                <div className="rounded-full bg-[#ff39b3] font-bold w-4 h-4 flex justify-center items-center absolute top-0 -left-1">
                  <span className="text-[0.8rem] text-white ">
                    {allmessage?.filter((m) => !m.readed).length}
                  </span>
                </div>
              )}
              <div
                className={`dropdown-menu transitioncss fixed ${
                  notificationPopup && sortedMessage?.length > 0
                    ? "block"
                    : "hidden"
                } ${
                  showeffect ? "modeleffect" : "popup"
                } max-w-[450px] right-10   top-10  z-50 max-h-[500px] overflow-y-scroll rounded-lg border border-2xl`}
              >
                <div className="bg-white shadow py-3 rounded-lg text-black">
                  <p
                    onClick={() => handleRead()}
                    className="text-right text-sm font-bold  text-[#0078ae] pr-2 cursor-pointer"
                  >
                    Mark all as read
                  </p>

                  {sortedMessage?.map((item) => (
                    <div
                      key={item._id}
                      onClick={async () => {
                        console.log("Notification clicked:", item);

                        if (!item?.readed && item?._id) {
                          await handleRead(item?._id);
                        }

                        const link = NotificationLink(item);
                        if (link) window.location.href = link;
                      }}
                      className="relative flex items-start gap-3 p-4 cursor-pointer transition-all min-h-[90px]"
                    >
                      {/* IMAGE */}
                      <div className="flex-shrink-0">
                        <img
                          className="w-14 h-14 rounded-full object-cover"
                          src={toAbsoluteUrl(
                            "/media/icons/displayProfilePlaceholder.png"
                          )}
                          alt="profile"
                        />
                      </div>

                      {/* CONTENT */}
                      <div className="flex-1 pr-6">
                        <div className="flex justify-between">
                          <span className="text-xs text-gray-400">
                            {DaysConverter(item?.createdAt)} Ago
                          </span>
                        </div>

                        <p
                          className={`text-sm mt-1 ${
                            !item?.readed
                              ? "font-bold text-black"
                              : "text-gray-500"
                          }`}
                        >
                          {item?.message?.slice(0, 100)}
                        </p>
                      </div>

                      {/* DELETE */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleDelete(item?._id);
                        }}
                        className="absolute top-2 right-2 cursor-pointer p-1 rounded-full hover:bg-gray-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-4 h-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18 18 6M6 6l12 12"
                          />
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              onClick={() => setShowRightHeader(!showRightHeader)}
              className="lg:hidden px-5 flex justify-between border-b border-neutral-300 py-3"
            >
              <div className="text-lg ">{data?.username}</div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            {/* <Link className='flex flex-1 items-center space-x-2 border-r border-text-gray-500 lg:pr-4 px-5' to="#">
   <svg xmlns="http://www.w3.org/2000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-5 h-5"><path fillRule="evenodd" d="M3.5 3a.5.5 0 00-.5.5v17a.5.5 0 00.5.5H6v-6h5v6h9.5a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5H14V3.5a.5.5 0 00-.5-.5h-10zM5 9h7v1H5V9zm7-3H5v1h7V6z" clipRule="evenodd"></path></svg>
   <div className='block'>
      <p className='-mb-1'>{data?.username}</p>
      <p className='text-[#767676] text-sm'><FormattedMessage id="INDIVIDUAL.TOPBAR.MENU.OWNER.TITLE" defaultMessage="owner" />:{data?.email}</p>
   </div>
      </Link> */}
            <Link
              className="flex items-center space-x-2 relative px-5 lg:px-0 z-50"
              to="#"
            >
              <svg
                onClick={HandleModel}
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
                role="img"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="w-5 h-5"
              >
                <path d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.992-5.996-4.5-9-4.5z"></path>
              </svg>
              <span onClick={HandleModel}> {data?.email}</span>
              <svg
                onClick={HandleModel}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-3 h-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
              {model && (
                <div
                  className={`${
                    showeffect ? "modeleffect" : "popup"
                  }  w-[22rem] transitioncss z-50 absolute top-14 right-2 bg-white rounded-lg border border-slate-400	`}
                >
                  <div className="p-4">
                    {/* <h1 className=' text-lg'>
        Vishal
    </h1> */}
                    {/* <ul>
        {ModelItems.map((data)=> (
          <Link to={'#'}>
        <li className='flex items-center space-x-2 py-3'>
        {data.icon}
        <span>{data.text}</span>
        </li>
        </Link>
        )) }
    </ul>
    <hr className='pt-2 border-slate-300'/> */}
                    <h1 className=" text-lg	 py-2">{data?.email}</h1>
                    <ul>
                      {ModelBottomItem.map((data, index) => (
                        <React.Fragment key={index}>
                          {index === 1 && (
                            <li className="py-3">
                              <button
                                type="button"
                                onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                                className="flex w-full items-center space-x-2 text-left"
                              >
                                <RefreshCw className="w-5 h-5" />
                                <span>Switch Profile</span>
                              </button>
                              {profileMenuOpen && (
                                <ProfileSwitcherOptions currentUserType="individual" />
                              )}
                            </li>
                          )}
                          <Link to={data.link ? data.link : "#"}>
                            <li
                              onClick={() =>
                                data.text.props.defaultMessage === "Sign Out" &&
                                logout()
                              }
                              className="flex items-center space-x-2 py-3"
                            >
                              {data.icon}
                              <span>{data.text}</span>
                            </li>
                          </Link>
                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </Link>
          </div>
        </div>
        {model ||
          (notificationPopup && (
            <span
              onClick={() => {
                notificationPopup && handleNotification();
                model && HandleModel();
              }}
              className="fixed w-full h-full z-[40] top-0 left-0 delay-100 visible"
            ></span>
          ))}
      </nav>
      {appSettingsData &&
      appSettingsData?.isPlatformPaymentActive != undefined &&
      appSettingsData?.isPlatformPaymentActive === true
        ? userFullProfile &&
          userFullProfile?.id &&
          userFullProfile?.type &&
          userFullProfile?.type !== "cleaner" &&
          (!userFullProfile?.id ||
          !userFullProfile?.stripe_customer_detail ||
          !userFullProfile?.stripe_customer_detail?.id ||
          !userFullProfile?.stripe_customer_payment_methods ||
          userFullProfile?.stripe_customer_payment_methods?.length == 0 ? (
            <div className="flex justify-center items-center gap-x-6 bg-red-400 px-6 py-2.5 sm:px-3.5">
              <p className="text-sm/6 text-white">
                {intl.formatMessage({
                  id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
                  defaultMessage: "Please setups your payment method first",
                })}
                <Link
                  to="/individual/Account?tab=payment-settings"
                  className="cursor-pointer"
                >
                  &nbsp;
                  <span aria-hidden="true">&rarr;</span>
                </Link>
              </p>
            </div>
          ) : !userFullProfile?.stripe_customer_detail ||
            !userFullProfile?.stripe_customer_detail?.default_payment_method ||
            userFullProfile?.stripe_customer_detail?.default_payment_method ==
              null ||
            userFullProfile?.stripe_customer_detail?.default_payment_method ==
              "null" ||
            userFullProfile?.stripe_customer_detail?.default_payment_method ==
              "" ? (
            <div className="flex justify-center items-center gap-x-6 bg-red-400 px-6 py-2.5 sm:px-3.5">
              <p className="text-sm/6 text-white">
                {intl.formatMessage({
                  id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
                  defaultMessage: "Please set a default payment method first",
                })}
                <Link
                  to="/individual/Account?tab=payment-settings"
                  className="cursor-pointer"
                >
                  &nbsp;
                  <span aria-hidden="true">&rarr;</span>
                </Link>
              </p>
            </div>
          ) : (
            ""
          ))
        : ""}
    </div>
  );
};
